import { useEffect, useState } from "react";

type Theme = "claro" | "escuro";

const storageKey = "vorno-drive-theme";

function storedTheme(): Theme {
  return localStorage.getItem(storageKey) === "escuro" ? "escuro" : "claro";
}

export function applyStoredTheme() {
  document.documentElement.dataset.theme = storedTheme();
}

export function ThemeToggle({ className = "" }: { className?: string }) {
  const [theme, setTheme] = useState<Theme>(storedTheme);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    localStorage.setItem(storageKey, theme);
  }, [theme]);

  return (
    <div className={`drive-theme-toggle ${className}`.trim()} role="group" aria-label="Escolher tema">
      <button
        type="button"
        title="Tema claro"
        aria-label="Usar tema claro"
        aria-pressed={theme === "claro"}
        className={theme === "claro" ? "active" : ""}
        onClick={() => setTheme("claro")}
      >
        <svg aria-hidden="true" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="4" />
          <path d="M12 2v2M12 20v2M4.93 4.93l1.42 1.42M17.65 17.65l1.42 1.42M2 12h2M20 12h2M4.93 19.07l1.42-1.42M17.65 6.35l1.42-1.42" />
        </svg>
      </button>
      <button
        type="button"
        title="Tema escuro"
        aria-label="Usar tema escuro"
        aria-pressed={theme === "escuro"}
        className={theme === "escuro" ? "active" : ""}
        onClick={() => setTheme("escuro")}
      >
        <svg aria-hidden="true" viewBox="0 0 24 24">
          <path d="M21 12.8A9 9 0 1 1 11.2 3 7 7 0 0 0 21 12.8Z" />
        </svg>
      </button>
    </div>
  );
}
